/* Mobile disclosure enhancements. Keep original nodes, content, forms and desktop markup. */
(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const folds = new Map();

  function fold(container, heading, open = false) {
    if (!heading || folds.has(container) || container.closest('.zb-mobile-fold')) return;
    const marker = document.createComment('Original heading position');
    heading.before(marker);
    const children = [...container.childNodes].filter(node => node !== heading);
    const details = document.createElement('details');
    details.className = 'zb-mobile-fold';
    details.open = open;
    const summary = document.createElement('summary');
    summary.append(heading);
    const symbol = document.createElement('span');
    symbol.className = 'zb-mobile-fold__symbol';
    symbol.setAttribute('aria-hidden', 'true');
    symbol.textContent = '+';
    summary.append(symbol);
    const body = document.createElement('div');
    body.className = 'zb-mobile-fold__body';
    children.forEach(node => body.append(node));
    details.append(summary, body);
    container.append(details);
    container.classList.add('zb-mobile-fold-host');
    folds.set(container, { details, body, marker, heading });
  }

  function restore(container, record) {
    const focused = record.details.contains(document.activeElement) ? document.activeElement : null;
    const summaryFocused = record.details.querySelector('summary') === focused;
    record.details.before(...record.body.childNodes);
    record.marker.replaceWith(record.heading);
    record.details.remove();
    container.classList.remove('zb-mobile-fold-host');
    if (summaryFocused) {
      record.heading.setAttribute('tabindex', '-1');
      record.heading.focus({ preventScroll: true });
      record.heading.addEventListener('blur', () => record.heading.removeAttribute('tabindex'), { once: true });
    } else if (focused?.isConnected) focused.focus({ preventScroll: true });
    folds.delete(container);
  }

  function init(root = document) {
    if (!mobile.matches) return;
    root.querySelectorAll('.zb-footer__column--support').forEach(node => fold(node, node.querySelector('h3')));
    root.querySelectorAll('.zb-about-chapter').forEach(node => fold(node, node.querySelector('h2'), node.id === 'about-chapter-1'));
    root.querySelectorAll('.zb-reviews-chapter').forEach(node => fold(node, node.querySelector('h2'), node.id === 'review-chapter-1'));
    root.querySelectorAll('.zb-contact-card').forEach(node => {
      const heading = node.querySelector('h2,h3');
      if (heading && /wholesale|response time|stay connected|thank you|here for you/i.test(heading.textContent)) fold(node, heading);
    });
    root.querySelectorAll('.zb-pdp-details-grid article').forEach((node, index) => fold(node, node.querySelector('h3'), index === 0));
    root.querySelectorAll('.zb-policy-links').forEach(node => {
      const heading = node.querySelector('.zb-policy-eyebrow');
      if (heading) fold(node, heading);
    });
  }

  function revealHash(hash = location.hash, scroll = false) {
    if (!hash || hash === '#') return;
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (_) { return; }
    if (!target) return;
    const own = target.querySelector(':scope > .zb-mobile-fold');
    if (own) own.open = true;
    for (let ancestor = target.parentElement; ancestor; ancestor = ancestor.parentElement) {
      if (ancestor.matches('details.zb-mobile-fold')) ancestor.open = true;
    }
    if (scroll) requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
  }

  function update() {
    if (mobile.matches) { init(); revealHash(); }
    else {
      [...folds].forEach(([node, record]) => restore(node, record));
    }
  }
  mobile.addEventListener('change', update);
  document.addEventListener('shopify:section:load', event => { init(event.target); revealHash(); });
  document.addEventListener('shopify:section:unload', event => {
    [...folds].forEach(([node, record]) => { if (event.target.contains(node)) restore(node, record); });
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.hash) revealHash(url.hash, true);
  });
  addEventListener('hashchange', () => revealHash(location.hash, true));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();
